export { LifeBuoy as default } from './LifeBuoy';
